<template>
  <!-- 合同管理 -->
  <div class="wrapper main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">合同名称</span>
          <Input v-model="searchParams.subject" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">合同编号</span>
          <Input v-model="searchParams.sn" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">机构/团队</span>
          <selectTree type="2" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">姓名</span>
          <Input v-model="searchParams.employName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">开始时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchParams.date"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">合同类型</span>
          <Select v-model="searchParams.type" filterable clearable>
            <Option value="1">新签</Option>
            <Option value="2">续签</Option>
            <Option value="3">解约</Option>
            <Option value="4">补签</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">状态</span>
          <Select v-model="searchParams.status" filterable clearable>
            <Option value="1">已生效</Option>
            <Option value="2">待生效</Option>
            <Option value="-1">已过期</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>
      <div class="tools-box right">
        <Button type="primary" @click="downloadZipAll">批量下载</Button>
        <Button type="primary" v-if="$units.pointAction('org_6_5')" @click="importData">批量导入</Button>
        <Button type="warning" v-if="$units.pointAction('org_6_2')" @click="$refs.editForm.open()">新增</Button>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部合同</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >项,共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table
          :columns="columns"
          :data="tableData"
          @on-select="onSelect"
          @on-select-cancel="onSelectCancel"
          @on-select-all="onSelect"
          @on-select-all-cancel="onSelectAllCancel"
        >
          <template slot-scope="{ row }" slot="action">
            <div class="detail">
              <div @click.stop="$refs.editForm.open(row)" v-if="$units.pointAction('org_6_2')">
                <span>编辑</span>
              </div>
              <div @click.stop="daochu(row)" v-if="row.documentUrls">
                <span>下载</span>
              </div>
              <div @click.stop="$refs.pdfPreview.open(row.documentUrls)">
                <span>预览</span>
              </div>
              <div @click.stop="del(row)" v-if="$units.pointAction('org_6_3')">
                <span>删除</span>
              </div>
            </div>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
      </div>
    </div>
    <!-- 修改基本信息  -->
    <editForm ref="editForm" @suceess="searchAjax()"></editForm>

    <!-- 导入 -->
    <import-tool ref="importTool" @success="searchAjax()"></import-tool>

    <!-- 合同预览 -->
    <contract-preview ref="pdfPreview"></contract-preview>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
import editForm from "./components/edit";
import selectTree from "@/components/system/selectTree3";
import importTool from './components/importTool';
import contractPreview from './components/contractPreview';

export default {
  components: {
    selectTree,
    editForm,
    importTool,
    contractPreview
  },
  mixins: [pageTool],
  props: {},
  data() {
    return {
      isAll: false,
      selectArr: [],//表格选择的数据
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "合同名称",
          key: "subject",
          align: "center",
          minWidth: 200,
          tooltip: true,
          render(h, params) {
            let text = params.row.subject;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text || '-'
                ),
                h('span', { slot: 'content' }, text || '-')
              ]
            );
          }
        },
        {
          title: "合同编号",
          key: "sn",
          align: "center",
          minWidth: 200,
        },
        {
          title: "合同类型",
          align: "center",
          minWidth: 100,
          render(h, param) {
            const map = {
              '1': '新签',
              '2': '续签',
              '3': '解约',
              '4': '补签',
            }
            return <span>{map[param.row.type] || '-'}</span>
          }
        },
        {
          title: "工号",
          key: "staffNo",
          align: "center",
          minWidth: 200,
        },
        {
          title: "所属机构",
          key: "orgName",
          align: "center",
          minWidth: 160,
        },
        {
          title: "所属团队",
          key: "groupName",
          align: "center",
          minWidth: 160,
        },
        {
          title: "姓名",
          key: "employName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "开始时间",
          key: "contractBeginDate",
          width: "140",
          align: "center",
        },
        {
          title: "结束时间",
          key: "contractEndDate",
          width: "140",
          align: "center",
          render(h, params) {
            let contractEndDate = params.row.contractEndDate;
            return <span>{contractEndDate ? contractEndDate : '-'}</span>
          }
        },
        {
          title: "状态",
          align: "center",
          minWidth: 100,
          render(h, param) {
            let status = param.row.status;
            if (status == '1') {
              return <span>已生效</span>
            } else if (status == '2') {
              return <span>待生效</span>
            } else if (status == '-1') {
              return <span>已过期</span>
            } else if (status == '0') {
              return <span>已终止</span>
            }
          }
        },
        {
          title: "创建时间",
          key: "createTime",
          width: "140",
          align: "center",
          render(h, params) {
            const date = params.row.createTime && params.row.createTime.substring(0, 10);
            return <span>{date}</span>;
          },
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "180",
          fixed: 'right'
        },
      ],
    };
  },

  mounted() {
    this.initListAjax("/buz/userContract/read/list");
    if (!this.$units.pointAction('org_6_2') && !this.$units.pointAction('org_6_3') && !this.$units.pointAction('org_6_6')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
  },
  activated() {
    this.getList()
  },
  methods: {

    listCallback(res) {
      res.data.forEach(item => {
        this.selectArr.forEach(item2 => {
          if (item.id == item2.id) {
            item._checked = true;
          }
        })
        if (this.isAll) {
          item._checked = true;
          item._disabled = true;
        }
      })
    },
    // 列表选中
    onSelect(selectArr) {
      selectArr.forEach(item => {
        this.selectPush(item);
      });
    },
    // 列表单个取消选中
    onSelectCancel(selectArr, row) {
      this.selectDel(row)
    },
    // 列表全选取消
    onSelectAllCancel() {
      this.tableData.forEach(item => {
        this.selectDel(item);
      });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 添加选择数据
    selectPush(data) {
      let has = false;
      this.selectArr.forEach(item => {
        if (item.id == data.id) {
          has = true;
        }
      });
      if (!has) {
        this.selectArr.push(data);
      }
    },
    // 去掉选择数据
    selectDel(data) {
      this.selectArr.forEach((item, i) => {
        if (item.id == data.id) {
          this.selectArr.splice(i, 1);
        }
      });
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.orgId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = "";
        this.searchParams.groupId = "";
      }
    },
    setReqParams(params) {
      params.apiPermissionCode = 'org_6_0';
    },
    // 转化参数
    setListParams(params) {
      if (params.date && params.date[0]) {
        params.contractBeginDateBigin = this.$units.formatDate(params.date[0]);
        params.contractBeginDateEnd = this.$units.formatDate(params.date[1]);
      }
      delete params.date;
      return params;
    },
    // 删除
    del(row) {
      this.$notice.inquiry("确定删除合同？").then(() => {
        this.$http({
          url: "/buz/userContract/del",
          type: "get",
          data: {
            id: row.id,
          },
          apiPermissionCode: 'org_6_3'
        }).then(res => {
          this.$notice.success("删除合同成功");
          this.searchAjax();
        })
      });
    },
    // 导出合同
    downloadZipAll() {
      if (!this.$units.pointAction('org_6_6')) {
        return this.$notice.msg("暂无下载权限");
      }
      if (!this.isAll && this.selectArr.length == 0) {
        return this.$notice.msg("请先勾选需要下载的合同");
      }
      this.listLoading = true;
      let searchParams = JSON.parse(JSON.stringify(this.searchParams));
      searchParams = this.setListParams(searchParams)
      console.log(searchParams)
      if (this.isAll) {
        searchParams.isAll = 1;
      } else {
        searchParams.isAll = 0;
        searchParams.ids = this.selectArr.map(item => item.id);
      }
      this.$http({
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        apiPermissionCode: 'org_6_6',
        url: `/buz/userContract/downloadZipAll`,
        data: searchParams,
      }).then(res => {
        this.$units.daochu(res);
      }).finally(() => {
        this.listLoading = false;
      })
    },
    // 导出合同
    daochu(row) {
      if (!this.$units.pointAction('org_6_6')) {
        return this.$notice.msg("暂无下载权限");
      }
      this.listLoading = true;
      this.$http({
        type: "GET",
        forced: true,
        responseType: "blob",
        All: true,
        url: `/buz/userContract/downloadZip`,
        data: {
          id: row.id
        },
        apiPermissionCode: 'org_6_6'
      }).then(res => {
        this.$units.daochu(res);
      }).finally(() => {
        this.listLoading = false;
      })
    },
    // 导入员工
    importData() {
      this.$refs.importTool.open({
        uploadUrl: "/buz/userContract/batch/upload",
        errorUrl: "/buz/userContract/exportError",
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.wrapper .content {
  /deep/ .detail span {
    font-size: 13px;
  }
}
</style>
